import {Application} from 'App';
import {AuthLayout} from 'containers/layouts/AuthLayout';
import {notAuthenticatedRoutes} from './notAuthenticatedRoutes';
import {BaseLayout} from 'containers/layouts/BaseLayout';
import {baseRoutes} from './baseRoutes';
import {PlanLayout} from 'containers/layouts/PlanLayout';
import {planRoutes} from './planRoutes';
import {ErrorBoundary} from './ErrorBoundary';
import {PlanRoute} from './PlanRoute';
import {ProtectedRoute} from './ProtectedRoute';
import {sentryCreateBrowserRouter} from '../integrations/sentry';

// defer execution of router creation as Sentry.init in index.tsx needs to be called first
export const router = () =>
  sentryCreateBrowserRouter([
    {
      element: <Application />,
      errorElement: <ErrorBoundary />,
      children: [
        {path: '/info', element: <AuthLayout />, children: notAuthenticatedRoutes},
        {
          path: '/',
          element: (
            <ProtectedRoute>
              <BaseLayout />
            </ProtectedRoute>
          ),
          children: baseRoutes,
        },
        {
          path: '/plan/',
          element: (
            <ProtectedRoute>
              <PlanRoute>
                <PlanLayout />
              </PlanRoute>
            </ProtectedRoute>
          ),
          children: planRoutes,
        },
      ],
    },
  ]);
